export default theme => ({
  segment_container: {
    width: "100%",
    height: 52,
    border: `1px solid ${theme.palette.shadow.main}`,
    position: "relative",
    marginRight: 20,
  },
  layout: {
    width: "100%",
    display: "flex",
    marginTop: 10,
  },
});
